class HomepageNewLines {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(this._elem.dataset.newLines)
        this._countdown = 500
    }
    onInit () {
        if (this._data.hasApple && this._data.hasAndroid) {
            this.waitForSlider()
        }
    }
    waitForSlider () {
        const appleSlider = this._elem.querySelector('[data-slider-apple]')
        const appleButton = this._elem.querySelector('[data-control-apple]')
        const androidSlider = this._elem.querySelector('[data-slider-android]')
        const androidButton = this._elem.querySelector('[data-control-android]')

        const appleInitialised = appleSlider.querySelector('.slick-initialized')
        const androidInitialised = appleSlider.querySelector('.slick-initialized')

        if (appleButton && appleSlider && androidButton && androidSlider && appleInitialised && androidInitialised) {
            androidSlider.classList.add('inactive')

            appleButton.addEventListener('click', () => {
                androidButton.classList.remove('homepage-new-lines__control--active')
                appleButton.classList.add('homepage-new-lines__control--active')
                appleSlider.classList.remove('inactive')
                androidSlider.classList.add('inactive')
                appleSlider.classList.add('active')
                androidSlider.classList.remove('active')
            })
            androidButton.addEventListener('click', () => {
                androidButton.classList.add('homepage-new-lines__control--active')
                appleButton.classList.remove('homepage-new-lines__control--active')
                appleSlider.classList.add('inactive')
                androidSlider.classList.remove('inactive')
                appleSlider.classList.remove('active')
                androidSlider.classList.add('active')
            })
        } else {
            if (this._countdown > 0) {
                this._countdown--
                window.requestAnimationFrame(() => { this.waitForSlider() })
            }
        }
    }
}

export default HomepageNewLines



// WEBPACK FOOTER //
// ./src/resources/scripts/components/HomepageNewLines.js